/* eslint-disable func-names */
/* eslint-disable comma-dangle */
import { UPDATE_DEFAULT_AIRPORT, UPDATE_DEFAULT_TENANT } from './types';

import { actionForState } from '../../../../utils/helpers';

const INITIAL_STATE = {
  error: {},
  apiStatusUser: {
    loading: false,
    success: undefined
  },
  profile: {
    id: '',
    fullname: '',
    airport: {
      location: {}
    },
    user: {
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      logo: ''
    },
    roles: [
      {},
      {}
    ]
  },
  action: {
    loading: false,
    success: undefined
  },
  tenantAction: {
    loading: false,
    success: false,
    error: false
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    /* ******************************** */
    /*           UPDATE USER            */
    /* ******************************** */
    case UPDATE_DEFAULT_AIRPORT.pending:
      return {
        ...state,
        action: {
          success: undefined,
          loading: true,
          type: 'update'
        },
        apiStatusUser: actionForState(state.action, 'pending')
      };
    case UPDATE_DEFAULT_AIRPORT.success:
      return {
        ...state,
        action: {
          ...state.action,
          success: true,
          loading: false,
          message: 'success'
        },
        user: action.payload,
        apiStatusUser: actionForState(state.action, 'success')
      };
    case UPDATE_DEFAULT_AIRPORT.error:
      return {
        ...state,
        action: {
          ...state.action,
          success: false,
          loading: false,
          message: 'failed'
        },
        error: action.payload?.response?.data,
        apiStatusUser: actionForState(state.action, 'error')
      };
    case UPDATE_DEFAULT_TENANT.pending:
      return {
        ...state,
        tenantAction: {
          loading: true,
          success: false,
          error: false,
        },
        apiStatusUser: actionForState(state.action, 'pending')
      };
    case UPDATE_DEFAULT_TENANT.success:
      return {
        ...state,
        action: {
          ...state.action,
          loading: true,
          success: true,
          error: false,
        },
        user: action.payload,
        apiStatusUser: actionForState(state.action, 'success')
      };
    case UPDATE_DEFAULT_TENANT.error:
      return {
        ...state,
        action: {
          ...state.action,
          loading: false,
          success: false,
          error: false,
        },
        error: action.payload?.response?.data,
        apiStatusUser: actionForState(state.action, 'error')
      };
    default:
      return state;
  }
}
